import React, { useEffect } from 'react';
import { useNotificationStore } from './NotificationStore';
import { useAuthStore } from '../../store/authStore';

export default function NotificationBell() {
  const { unreadCount, toggleDrawer, fetchNotifications } = useNotificationStore();
  const { token } = useAuthStore();

  useEffect(() => {
    if (!token) return;
    fetchNotifications(token);
    const int = setInterval(() => fetchNotifications(token), 30000);
    return () => clearInterval(int);
  }, [token, fetchNotifications]);

  return (
    <button onClick={toggleDrawer} className="relative p-2 text-white/70 hover:text-white transition-colors group">
      <svg className={`w-6 h-6 ${unreadCount > 0 ? 'group-hover:animate-swing' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
      {unreadCount > 0 && (
        <span className="absolute top-1 right-1 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold text-white bg-red-500 rounded-full">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}
